// extracted by mini-css-extract-plugin
export var previewContainer = "_sp-0";